import React, { useEffect } from 'react'
import { callNativeByParams, isApp } from '@penguin/utils'
const LINKS = {
  card: 'wexin://program?userName=gh_6506303a12bb&path=ad-bdlm-sub/pages/wh-coupon-guide/index?scene=51a6a9771e714e40a83903c7fa39a804',
  store:
    'wexin://program?userName=gh_6506303a12bb&path=commercialize/pages/taoke-guide/index?scene=66706d0b47af499f88238e4312f3bf80',
}

const ElePage = () => {
  useEffect(() => {
    document.title = '限时福利！0元领饿了么吃货卡'
  }, [])
  return (
    <div>
      <div className='absolute top-0 left-0 w-full' style={{ fontSize: 0 }}>
        <img src='https://static.qiekj.com/static/web/image/ele-01_1735092188969.jpg' alt='' />
        <img src='https://static.qiekj.com/static/web/image/ele-02_1735092188969.jpg' alt='' />
        <img src='https://static.qiekj.com/static/web/image/ele-03_1735092188969.jpg' alt='' />
      </div>
      <div className='flex relative flex-col items-center'>
        <div
          onClick={() => {
            if (isApp()) {
              callNativeByParams('jumpNativePage', {
                url: LINKS.card,
              })
            } else {
              window.location.href = LINKS.card
            }
          }}
          className='w-full h-[1000px] rem:mt-[400px]'
        ></div>
        <div
          onClick={() => {
            if (isApp()) {
              callNativeByParams('jumpNativePage', {
                url: LINKS.store,
              })
            } else {
              window.location.href = LINKS.store
            }
          }}
          className='w-full h-[600px] rem:mt-[100px]'
        ></div>
      </div>
    </div>
  )
}

export default ElePage
